import { useQuery } from '@tanstack/react-query';
import { type JSX } from 'react';
import { useParams } from 'react-router';
import { charactersApi } from '../api/library.js';
import { useI18n } from '../i18n/context.js';

/** Read-only карточка: support видит все исходные фото и все варианты героя. */
export function SupportCharacterPage(): JSX.Element {
  const { t } = useI18n();
  const { id = '' } = useParams();
  const character = useQuery({
    queryKey: ['support-character', id],
    queryFn: () => charactersApi.supportGet(id),
    enabled: Boolean(id),
  });

  if (character.isPending) return <p>{t.common.loading}</p>;
  if (character.isError) return <p role="alert">{t.common.unexpectedError}</p>;

  const item = character.data;
  return (
    <section className="mx-auto grid max-w-5xl gap-6">
      <div>
        <h1 className="text-2xl font-semibold">{t.support.characterTitle(item.name)}</h1>
        <p className="mt-1 text-sm text-[var(--kitup-color-muted)]">ID: {item.id}</p>
      </div>

      <section>
        <h2 className="font-semibold">{t.library.photos.title}</h2>
        <div className="mt-3 flex flex-wrap gap-3">
          {item.photos.map((photo) => (
            <figure key={photo.assetId} className="w-40">
              <img
                src={photo.url}
                alt={t.library.photos.slots[photo.slot]}
                className="w-40 rounded"
              />
              <figcaption className="mt-1 text-sm">{t.library.photos.slots[photo.slot]}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      {item.renditions.map((rendition) => (
        <section key={rendition.id} className="kitup-card p-4">
          <h2 className="font-semibold">{t.support.renditionTitle(rendition.styleId)}</h2>
          <p className="mt-1 text-sm text-[var(--kitup-color-muted)]">
            {t.library.rendition.statuses[rendition.status]}
          </p>
          <div className="mt-3 flex flex-wrap gap-3">
            {rendition.variants.map((variant) => (
              <figure key={variant.id} className="w-48">
                <img src={variant.url} alt="" className="w-48 rounded" />
                <figcaption className="mt-1 break-all text-xs">{variant.id}</figcaption>
              </figure>
            ))}
          </div>
        </section>
      ))}
    </section>
  );
}
